import { SettingOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { type ColumnType } from 'antd/es/table';
import type * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from '../../drawer/Drawer.tsx';
import { FlexRow } from '../../row/FlexRow.tsx';
import { ColumnPickerForm } from './form/ColumnPickerForm.tsx';
import { type ColumnPickerConfig } from './form/ColumnPickerSchema.tsx';
import { ColumnPickerList } from './item/ColumnPickerList.tsx';

export interface IColumnPickerProps<T> {
  columns?: Array<ColumnType<T>>;
  id: string | undefined;
  onChange?: (columns: ColumnPickerConfig) => void;
  extra?: React.ReactNode;
  extraColumns?: Array<ColumnType<T>>;
}

/**
 *
 */
export function ColumnPicker<T>(props: IColumnPickerProps<T>) {
  const { columns, id, onChange, extra, extraColumns } = props;
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();
  const drawerTitle = t('column-picker.drawer-title', 'Configurazione Colonne');

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (!columns?.length) return null;
  if (!id) return null;

  return (
    <>
      <Button
        aria-label={drawerTitle}
        type="link"
        icon={<SettingOutlined aria-hidden="true" />}
        onClick={showDrawer}
      />
      <Drawer
        title={<FlexRow right={extra}>{drawerTitle}</FlexRow>}
        onClose={onClose}
        open={open}
        width={420}
        destroyOnClose
      >
        <ColumnPickerForm
          {...props}
          onSave={nextConfig => {
            setOpen(false);
            onChange?.(nextConfig);
          }}
        >
          <ColumnPickerList
            {...props}
            onCloseDrawer={onClose}
            extraColumns={extraColumns}
          />
        </ColumnPickerForm>
      </Drawer>
    </>
  );
}
